// Electrostatic Capacitance units with conversion factors to farad (F)
export const capacitanceUnits = [
  { id: 'farad', name: 'Farad', symbol: 'F', plural: 'Farads', factor: 1 },
  { id: 'exafarad', name: 'Exafarad', symbol: 'EF', plural: 'Exafarads', factor: 1e18 },
  { id: 'petafarad', name: 'Petafarad', symbol: 'PF', plural: 'Petafarads', factor: 1e15 },
  { id: 'terafarad', name: 'Terafarad', symbol: 'TF', plural: 'Terafarads', factor: 1e12 },
  { id: 'gigafarad', name: 'Gigafarad', symbol: 'GF', plural: 'Gigafarads', factor: 1e9 },
  { id: 'megafarad', name: 'Megafarad', symbol: 'MF', plural: 'Megafarads', factor: 1e6 },
  { id: 'kilofarad', name: 'Kilofarad', symbol: 'kF', plural: 'Kilofarads', factor: 1e3 },
  { id: 'hectofarad', name: 'Hectofarad', symbol: 'hF', plural: 'Hectofarads', factor: 1e2 },
  { id: 'dekafarad', name: 'Dekafarad', symbol: 'daF', plural: 'Dekafarads', factor: 1e1 },
  { id: 'decifarad', name: 'Decifarad', symbol: 'dF', plural: 'Decifarads', factor: 1e-1 },
  { id: 'centifarad', name: 'Centifarad', symbol: 'cF', plural: 'Centifarads', factor: 1e-2 },
  { id: 'millifarad', name: 'Millifarad', symbol: 'mF', plural: 'Millifarads', factor: 1e-3 },
  { id: 'microfarad', name: 'Microfarad', symbol: 'µF', plural: 'Microfarads', factor: 1e-6 },
  { id: 'nanofarad', name: 'Nanofarad', symbol: 'nF', plural: 'Nanofarads', factor: 1e-9 },
  { id: 'picofarad', name: 'Picofarad', symbol: 'pF', plural: 'Picofarads', factor: 1e-12 },
  { id: 'femtofarad', name: 'Femtofarad', symbol: 'fF', plural: 'Femtofarads', factor: 1e-15 },
  { id: 'attofarad', name: 'Attofarad', symbol: 'aF', plural: 'Attofarads', factor: 1e-18 },
  { id: 'coulomb-per-volt', name: 'Coulomb/Volt', symbol: 'C/V', plural: 'Coulombs/Volt', factor: 1 },
  { id: 'abfarad', name: 'Abfarad', symbol: 'abF', plural: 'Abfarads', factor: 1e9 },
  { id: 'statfarad', name: 'Statfarad', symbol: 'statF', plural: 'Statfarads', factor: 1.112650e-12 },
];

export const popularCapacitanceConversions = [
  { from: 'farad', to: 'microfarad' },
  { from: 'microfarad', to: 'farad' },
  { from: 'microfarad', to: 'picofarad' },
  { from: 'picofarad', to: 'microfarad' },
  { from: 'microfarad', to: 'nanofarad' },
  { from: 'nanofarad', to: 'picofarad' },
];

export const getUnitById = (id) => capacitanceUnits.find(unit => unit.id === id);

export const convertCapacitance = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electrostatic capacitance units and learn the conversion formula.`;
};
